import { api } from '@/services/api/AxiosBaseService'
import { createCrudService } from '@/services/api/createCrudService'

export interface DiscountCoupon {
  id: string
  code: string
  value: number
  priceInCents: number
  discountType: 'PORCENTAGEM' | 'VALOR'
  monthlyInstallments: number | null
  startDate: string | null
  endDate: string | null
  status: 'ATIVO' | 'INATIVO'
  plans?: { id: string; name: string }[]
  formatted?: { value?: string; startDate?: string; endDate?: string }
}

const baseCoupons = createCrudService<DiscountCoupon>(
  '/commercial/discount-coupons',
  { searchField: 'code' },
)

export const DiscountCouponsService = {
  ...baseCoupons,

  /**
   * Valida um cupom pelo código para um plano específico. Retorna o cupom
   * (se válido/vigente e aplicável ao plano) ou `null` (404).
   */
  async findByCode(code: string, planId: string): Promise<DiscountCoupon | null> {
    try {
      const r = await api.get<{ data: DiscountCoupon }>('/commercial/discount-coupons/find-by-code', {
        params: { code, plan_id: planId },
      })
      return r.data.data
    } catch {
      return null
    }
  },
}
